import { black1, grey } from 'app/components/ThemeProvider/colors';

export const selectBox = (lang: boolean) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    width: lang ? '80px' : '320px',
    gap: '8px',

    '@media screen and (max-width: 1100px)': {
      width: '100%',
      // 'calc((100% - 28px) / 2)',
    },
  };
};

export const selectStyles = {
  control: (base?: any, state?: any) => ({
    ...base,
    height: '48px',
    borderWidth: '1px',
    borderStyle: ' solid',
    borderColor: state?.isFocused ? grey : ' rgba(20, 25, 31, 0.10)',
    borderRadius: '8px',

    // borderColor: state.isFocused && 'red',
    boxShadow: state?.isFocused ? null : null,
    '&:hover': {
      cursor: 'pointer',
      borderColor: grey,
    },
  }),

  container: (base: any) => ({
    ...base,
  }),
  menu: (base: any, state: any) => ({
    ...base,

    borderRadius: '8px',
    position: 'absolute',
    right: '1px',
    marginTop: 0,
    padding: 0,
    boxShadow: '0px 0px 32px 0px rgba(0, 0, 0, 0.06)',
  }),
  menuList: (base: any) => ({
    ...base,

    padding: '16px 0',
    fontFamily: 'Yelo',
  }),

  placeholder: (base: any) => ({
    ...base,
    paddingLeft: '16px',
    fontWeight: '400',
    fontSize: '16px',
    fontFamily: 'Yelo',
    color: 'rgba(20, 25, 31, 0.40)',
    marginLeft: 0,
    marginRight: 0,
  }),

  valueContainer: (base: any, state: any) => ({
    ...base,
    padding: 0,
    margin: 0,
    background: 'transparent',
    fontWeight: 500,
  }),

  singleValue: (base: any) => ({
    ...base,
    margin: 0,
    padding: '12px 16px',
    fontFamily: 'Yelo',
  }),

  input: (base: any) => ({
    ...base,
    // margin: 0,
    paddingLeft: '14px',
    // width: 0,
    // height: 0,
  }),

  dropdownIndicator: (base: any, state: any) => ({
    ...base,
    padding: 0,
    transform: state.selectProps.menuIsOpen && 'rotate(180deg)',
  }),

  option: (base: any, state: any) => ({
    ...base,
    color: state.isDisabled ? grey : black1,
    background: state.isSelected ? '#F3F4F6!important' : 'transparent',
    paddingLeft: '19px',
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    cursor: state.isDisabled ? 'not-allowed' : 'default',
    '&:hover': !state.isDisabled && { background: '#F3F4F6!important', cursor: 'pointer' },
  }),

  menuPortal: (base: any) => ({ ...base, zIndex: '1000000' }),

  indicatorsContainer: (base: any) => ({ ...base, paddingRight: '8px' }),
};
